import { render, staticRenderFns } from "./LoadingContainer.vue?vue&type=template&id=8423db66&"
import script from "./LoadingContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports